export default {
    booking: {
        services: {
            full: "Votre restaurant est complet ?",
            delete: "Êtes-vous sûr de vouloir supprimer ce service ?",
            removeFull: "Ouvrir le service aux réservations ?",
            serviceBuilderV2Migration:
                "Cette action est irréversible. Les services existants seront convertis vers la nouvelle édition : empreinte bancaire activée deviendra carte sécurisée + empreinte bancaire, prépaiement activé deviendra carte sécurisée + prépaiement, et les autres services resteront sans paiement sécurisé. Voulez-vous continuer ?",
            openServiceForDate: 'Le service "{service}" sera ouvert aux réservations pour le {date}. Voulez-vous continuer ?',
            openSlotForDate: 'Le créneau de {hour} pour le service "{service}" sera ouvert aux réservations pour le {date}. Voulez-vous continuer ?',
        },
        menus: {
            delete: "Êtes-vous sûr de vouloir supprimer ce menu ?",
        },
    },
};
